import { render } from "./practice-chart-doughnut.vue?vue&type=template&id=176fa89a&scoped=true"
import script from "./practice-chart-doughnut.vue?vue&type=script&lang=js"
export * from "./practice-chart-doughnut.vue?vue&type=script&lang=js"

import "./practice-chart-doughnut.vue?vue&type=style&index=0&id=176fa89a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176fa89a"]])

export default __exports__